<template>
    <DashboardContainer>
        <add-campaigns/>
    </DashboardContainer>
</template>

<script>
import DashboardContainer from '../containers/DashboardContainer'
import AddCampaigns from '../components/marketing/AddCampaigns'

export default {
    name: 'emailCampaigns',
    beforeCreate: function () {
        var auth = this.$storage.get('auth')
        if (!auth) {
            this.$router.push('/login')
        }else{
            if(!auth.token){
                this.$router.push('/login')
            }
        }
    },
    components: {
        DashboardContainer,
        AddCampaigns,
    }
}
</script>